import React, { useState } from 'react'
import { useStyles } from './FlyoutCasProgramSetupWrapper.styles'
import { BoxV2, ExternalLink } from '@labrav/react-components'
import { HelpDrawer } from '@labrav/common'
import DataFeedsImage from '../../../common/images/DataFeedsImage.png'
import WhatAreYouDoingHereData from '../../../mocks/whatAreYouDoingHere.json'
import { Typography } from '@mui/material'
import { newDataFeedProgramLink } from '../../../common/utils/constants'
import { VideoModal } from '../../../common/components/ProductVideoAction/VideoModal'

export type FlyoutCasProgramSetupWrapperProps = {
  children: JSX.Element
}
export const FlyoutCasProgramSetupWrapper: React.FC<
  FlyoutCasProgramSetupWrapperProps
> = ({ children }) => {
  const { classes } = useStyles()

  const [isVideoOpen, setIsVideoOpen] = useState(false)
  const handleAlreadyEnrolledCasThumnailClick = () => {
    setIsVideoOpen(true)
  }

  return (
    <BoxV2
      heading={'Data feeds '}
      // isOptional={true}
      headingIcon="STEP 03"
      secondaryActions={
        <HelpDrawer sectionName="flyoutDataFeedSetup" headerTitle="Help" />
      }
    >
      <>
        <div
          className={classes.subHeadingContainer}
          data-testid="data-feeds-text-and-link"
        >
          <Typography className={classes.subHeading}>
            In this section you setup Data feeds, which helps labra track your
            invoices and disbursements. Click on the "Launch cloudformation
            stack" <br /> button below to create the S3 bucket. Once done, paste
            the values obtained from the output section below and on {''}
            <ExternalLink href={newDataFeedProgramLink}>
              this link
            </ExternalLink>{' '}
            as well.
          </Typography>
        </div>
        <div className={classes.content}>
          <div> {children}</div>
          <div className={classes.verticalDivider}></div>
          <div>
            <div
              className={classes.videoWrapper}
              data-testid={'vertical-divider-data-feeds'}
            >
              <div
                className={classes.videoContainer}
                data-testid="video-cloud-settings-data-feeds"
              >
                <div className={classes.thumbnailWrapper}>
                  <img
                    className={classes.thumbnailImages}
                    src={DataFeedsImage}
                    title="Labra FlyOut"
                    alt={'what-are-you-doing-here'}
                    onClick={handleAlreadyEnrolledCasThumnailClick}
                  />
                </div>
              </div>
              <div data-testid="video-link-cloud-settings-data-feeds">
                <ExternalLink
                  href={WhatAreYouDoingHereData.cloudSettingDataFeeds.video}
                >
                  {WhatAreYouDoingHereData.cloudSettingDataFeeds.linkText}
                </ExternalLink>
              </div>
            </div>
          </div>
        </div>
        <VideoModal
          actionTitle="Data feeds "
          actionLable=""
          isVideoModalOpen={isVideoOpen}
          setIsVideoModalOpen={setIsVideoOpen}
          videoLink={WhatAreYouDoingHereData.cloudSettingDataFeeds.video}
        />
      </>
    </BoxV2>
  )
}
